import { merge } from 'lodash-es';
import { computed, useAttrs } from 'vue';

export function useL10n(props: Record<string, any>) {
    const attrs = useAttrs();

    const l10n = computed(() => merge({}, attrs, props, props.translations ?? {}));

    return {
        l10n,
    };
}
